import { render, staticRenderFns } from "./paginaRaiz.vue?vue&type=template&id=5e2990bb"
import script from "./paginaRaiz.vue?vue&type=script&lang=js"
export * from "./paginaRaiz.vue?vue&type=script&lang=js"
import style0 from "./paginaRaiz.vue?vue&type=style&index=0&id=5e2990bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports